export const DASHBOARD_CHART_SIZE = 200;

export const autoRecallFeatureFlags = {
  autoRecallDemoData: 'auto-recall-analytics-demo-data',
  disableAutoRecallInAnalytics: 'disable-auto-recall-in-analytics',
};
